import * as React from "react";
import styled from "styled-components";
import { Hidden, Drawer } from "@material-ui/core";

type Props = {
  getBody: () => JSX.Element;
  open: boolean;
  setOpen: (val: boolean) => void;
  width: number;
  allowDrawer: boolean;
};

const StyledWrapper = styled.div<{ open: boolean; width: number }>`
  box-shadow: ${props => props.theme.shadow.primary};
  pointer-events: ${props => (props.open ? "all" : "none")};
  width: ${props => (props.open ? props.width : 0)}px;
  max-width: 100vw;
  overflow: hidden;
  height: 100%;
  position: relative;
  background-color: white;
  transition: width 0.15s cubic-bezier(0.075, 0.82, 0.165, 1);

  ${props => props.theme.breakpoints.down("xs")} {
    max-width: 100vw;
  }
`;

const StyledBody = styled.div<{ open: boolean; width: number }>`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: ${props => (props.open ? props.width : 0)}px;
  max-width: 100vw;
  overflow: auto;
  transition: width 0.15s cubic-bezier(0.075, 0.82, 0.165, 1);

  ${props => props.theme.breakpoints.down("xs")} {
    max-width: 100vw;
  }
`;

export const RightPanel: React.FunctionComponent<Props> = props => {
  const { getBody, open, setOpen, width, allowDrawer } = props;

  return (
    <>
      <Hidden mdDown>
        <StyledWrapper open={open} width={width}>
          <StyledBody width={width} open={open}>
            {getBody()}
          </StyledBody>
        </StyledWrapper>
      </Hidden>
      {allowDrawer && (
        <Hidden lgUp>
          <Drawer anchor={"right"} open={open} onClose={() => setOpen(false)}>
            <StyledWrapper open width={width}>
              {getBody()}
            </StyledWrapper>
          </Drawer>
        </Hidden>
      )}
    </>
  );
};
